/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityEntityResult { 
    /**
     * Commercial name of the entity.
     */
    commercialName?: string;
    /**
     * Logo of the entity. Encoded in Base64 format
     */
    logo?: IdentityEntityResult.LogoEnum;
    /**
     * Public key of the entity. Encoded in Base64 format
     */
    publicKey?: IdentityEntityResult.PublicKeyEnum;
    /**
     * Entity type: ServiceProvider (true) or Issuer (false).
     */
    serviceProviderOrIssuer?: boolean;
}
export namespace IdentityEntityResult {
    export const LogoEnum = {
        B61d84e08: '[B@61d84e08'
    } as const;
    export type LogoEnum = typeof LogoEnum[keyof typeof LogoEnum];
    export const PublicKeyEnum = {
        B2d9f64c9: '[B@2d9f64c9'
    } as const;
    export type PublicKeyEnum = typeof PublicKeyEnum[keyof typeof PublicKeyEnum];
}


